import React, { useEffect, useRef, useState } from "react";
import { withTranslation } from "react-i18next";
import { get, isEmpty } from "lodash";
import { request } from "../../../utils/Request";
import UrlHelper from "js-url-helper";
import qs from "qs";
import { Route, Routes, useLocation } from "react-router-dom";
import { Toast } from "primereact/toast";
import OrderTransportRequestList from "./partials/OrderTransportRequestList";

const DEFAULT_DROPDOWNS = {
    locations: [],
    brands: [],
    models: [],
    clients: [],
    providers: [],
    statuses: [],
    dealers: [],
    drivers: [],
    transportVehicles: [],
    automaticStartNextJourney: []
};

const url = new UrlHelper();

const OrderTransportRequests = (props: any) => {
    const { t } = props;
    const toast = useRef(null);
    const [dropdowns, setDropdowns] = useState<any>(null);
    const { state } = useLocation();

    const [moduleState, setModuleState] = useState<any>({
        page: 1,
        per_page: 20,
        search: null,
        initialized: false,
        filters: []
    });

    const getDropdowns = async () => {
        try {
            const response = await request({
                url: '/suppliers/orders/transport/requests/create',
                params: {
                    type: 'list',
                }
            });
            const { data } = response.data;

            setDropdowns({
                locations: data.locations.map((item: any) => ( { ...item, key: item.id } )),
                clients: data.clients,
                providers: data.providers || [],
                brands: data.brands,
                models: data.models,
                statuses: data.statuses,
                drivers: data.drivers,
                dealers: data.dealers,
                transportVehicles: data.transportVehicles,
                automaticStartNextJourney: data.automaticStartNextJourney
            });
        } catch (e) {
            setDropdowns(DEFAULT_DROPDOWNS);
        } finally {
            const prevUrl = qs.parse(url.getSearchParam().prev_url ?? "");

            setModuleState({
                page: !isEmpty(prevUrl.page) ? url.getSearchParam().page : 1,
                per_page: !isEmpty(prevUrl.per_page) ? url.getSearchParam().per_page : 20,
                search: !isEmpty(prevUrl.search) ? url.getSearchParam().search : null,
                initialized: true,
            });
        }
    };

    useEffect(() => {
        document.title = t("order transport requests");

        async function init() {
            await getDropdowns();
        }

        init();
    }, []);

    const toastify = (message: any, color: string = 'info', summary: any = null) => {
        if ( toast && toast.current ) {
            // @ts-ignore
            toast.current.show({ severity: color, summary: summary, detail: message });
        }
    };

    return (
        <div className={ "module-container" }>
            <Toast ref={ toast } />
            <div className="layout-content">
                { ( moduleState && moduleState.initialized ) ?
                    <React.Fragment>
                        <Routes>
                            <Route path={ "/" } element={
                                <OrderTransportRequestList
                                    moduleState={ moduleState }
                                    dropdowns={ dropdowns }
                                    toastify={ toastify }
                                    setQuery={ setModuleState }
                                /> } />
                        </Routes>
                    </React.Fragment>
                    : <h6>{ t('loading') }</h6> }
            </div>
        </div>
    );
};

export default withTranslation()(OrderTransportRequests);

